import { Id, UserEmailNotification } from 'src/types'

export const initialValues = {} as UserEmailNotification

export function getDefaultValue(organization_id: Id): UserEmailNotification {
  return {
    active: true,
    attach_travel_report: true,
    email: '',
    notification_status: 'APPROVAL_PENDING',
    organization_id,
    reason_id: '',
    user_email_notification_id: new Date().toJSON(),
    validate_reason: true
  }
}
